/**
 * Lifting Operations Checklist
 * Crane or davit operations
 * Regulatory: LOLER, PUWER
 */

export const LIFTING_OPERATIONS_CHECKLIST = {
  id: 'lifting_operations',
  name: 'Lifting Operations',
  description: 'Crane or davit operations',
  icon: 'ArrowUpFromLine',
  regulatory: 'LOLER, PUWER',
  isCustomisable: true,
  items: [
    { id: 'lift_1', text: 'Lifting equipment inspected and in date', required: true },
    { id: 'lift_2', text: 'Load weight known and within SWL', required: true },
    { id: 'lift_3', text: 'Exclusion zone established', required: true },
    { id: 'lift_4', text: 'Signaller/banksman appointed', required: true },
    { id: 'lift_5', text: 'Weather conditions suitable', required: true },
    { id: 'lift_6', text: 'Tag lines rigged if required', required: false }
  ]
};
